import { Trans, useTranslation } from 'react-i18next';

import { LargePanePage, PageTitle } from 'components';

import { AnalyticsCategoryProvider, Categories } from '@app/analytics';
import { SignupForm } from './SignupForm';

export const ClientSignup = () => {
  const code = new URLSearchParams(window.location.search).get('code');
  const { t } = useTranslation();

  return (
    <AnalyticsCategoryProvider category={Categories.SIGNUP}>
      <LargePanePage
        color="red"
        panelContent={
          <h1>
            <Trans i18nKey="signup.client.largeTitle" />
          </h1>
        }
      >
        <SignupForm promoCode={code || undefined} />
        <PageTitle title={t('signup.metaTitle')} />
      </LargePanePage>
    </AnalyticsCategoryProvider>
  );
};
